import Router from 'next/router';
import { type CSSProperties, memo, useCallback } from 'react';

import { useTrackClickedPublicBoardLink } from '@air/analytics';
import { useAirModal } from '@air/provider-modal';

import { SignupModal } from '~/components/Modals/SignupModal/SignUpModal';

export type PublicSignUpButtonProps = {
  /** Optional inline style — e.g. a share link's derived header foreground color so the CTA stays readable on a custom header background. */
  style?: CSSProperties;
};

export const PublicSignUpButton = memo(({ style }: PublicSignUpButtonProps) => {
  const [showSignUpModal] = useAirModal(SignupModal);
  const { trackClickedPublicBoardLink } = useTrackClickedPublicBoardLink();

  const onSignUpClick = useCallback(() => {
    showSignUpModal({
      ssoCallbackData: {
        url: Router.asPath,
      },
      accountCreationSource: 'share-link',
    });

    trackClickedPublicBoardLink({
      name: 'clicked login',
      page_area: 'banner',
      page_type: 'public board',
    });
  }, [showSignUpModal, trackClickedPublicBoardLink]);

  return (
    <button
      className="cursor-pointer px-0.5 font-semibold ads:text-secondary text-14 text-gray-10 hover:underline"
      data-testid="PUBLIC_SIGN_UP_BUTTON"
      onClick={onSignUpClick}
      style={style}
      type="button"
    >
      Sign up
    </button>
  );
});

PublicSignUpButton.displayName = 'PublicSignUpButton';
